<template>
    <div>
    </div>
  </template>
  
  <script>
  import Swal from 'sweetalert2';
  
  export default {
    name: 'AlertComponent',
    props: {
      title: {
        type: String,
        required: true
      },
      text: {
        type: String,
        required: true
      },
      showAlert: {
        type: Boolean,
        default: false
      },
      alertType: {
        type: String,
        default: 'error'  
      },
      confirmButtonText: {
        type: String,
        default: 'Cerrar' 
      }
    },
    watch: {
      showAlert: function(newVal) {
        if (newVal) {
          this.showAlertDialog();
        }
      }
    },
    methods: {
      //icons =  ['warning', 'error', 'success', 'info', 'question']
      showAlertDialog() {
        switch (this.alertType) {
          case 'warning':
            this.showAlertDialogWarning();
            break;
          case 'success':
            this.showAlertDialogSuccess();
            break;
          case 'info':
            this.showAlertDialogInfo();
            break;
          case 'error':
          default:
            this.showAlertDialogError();
            break;
        }
      },
      showAlertDialogError() {
        Swal.fire({
          title: this.title,
          text: this.text,
          icon: 'error',
          confirmButtonText: this.confirmButtonText,
          confirmButtonColor: '#244125',
          didOpen: () => {
              const swalContainer = document.querySelector('.swal2-container');
              if (swalContainer) {
                  swalContainer.style.zIndex = '3000';
              }
          },          
          customClass: {
            confirmButton: 'my-confirm-button',
          }
        }).then(() => {
          this.$emit('close');
        });
      },
      showAlertDialogWarning() {
        Swal.fire({
          title: this.title,
          text: this.text,
          icon: 'warning',
          confirmButtonText: this.confirmButtonText,
          confirmButtonColor:'#eaf117',
          didOpen: () => {
              const swalContainer = document.querySelector('.swal2-container');
              if (swalContainer) {
                  swalContainer.style.zIndex = '3000';
              }
          }
        }).then(() => {
          this.$emit('close');
        });
      },
      showAlertDialogSuccess() {
        Swal.fire({
          title: this.title,
          text: this.text,
          icon: 'success',
          confirmButtonText: this.confirmButtonText,
          confirmButtonColor: '#7aa57a9c',
          didOpen: () => {
              const swalContainer = document.querySelector('.swal2-container');
              if (swalContainer) {
                  swalContainer.style.zIndex = '3000';
              }
          }          
        }).then(() => {
          this.$emit('close');
        });
      },
      showAlertDialogInfo() {
        Swal.fire({
          title: this.title,
          text: this.text,
          icon: 'info',
          confirmButtonText: this.confirmButtonText,
          confirmButtonColor: '#33b5ff',
          didOpen: () => {
              const swalContainer = document.querySelector('.swal2-container');
              if (swalContainer) {
                  swalContainer.style.zIndex = '3000';
              }
          }          
        }).then(() => {
          this.$emit('close');
        });
      }
    }
  };
  </script>
  
  <style>
    .my-confirm-button {
      color: #ffffff !important;
    }
    .swal2-container {
      z-index: 3000 !important;
    }
  </style>